export const CONFIG = [
    {
        editUrl: '#onboarding/organization',
        hash: '#onboarding/organization',
        key: 'hasOrganizationData',
        label: 'Company Information',
        text: 'Complete your company information',
    },
    {
        editurl: '/subscriptions',
        hash: '#onboarding/subscriptions',
        key: 'hasSubscriptions',
        label: 'Share your Preferences',
        text: 'Let us find your brands and products',
    },
    {
        editUrl: '#onboarding/confirmation',
        hash: '#onboarding/confirmation',
        key: 'hasConfirmedEmail',
        label: 'Confirm your Email',
        text: 'Check your inbox or resend the email',
    },
    {
        editUrl: '#onboarding/financing',
        hash: '#onboarding/financing',
        key: 'hasFinancing',
        label: 'Discover smatch Financing',
        text: 'Exclusive 15, 30, 60, 90 or 120 day financing',
    },
    {
        editUrl: '#onboarding/logistics',
        hash: '#onboarding/logistics',
        key: 'hasDeliveryAddress',
        label: 'Discover smatch Logistics',
        text: 'Managed international shipping',
    },
    {
        editUrl: '#onboarding/organization-users',
        hash: '#onboarding/organization-users',
        key: 'hasAddedUsers',
        label: 'Invite Your Colleagues',
        text: 'Add your colleagues to smatch',
    },
];